import { updateExternalConnection as _updateExternalConnection } from '@griply/services';
import { ExternalConnection } from '@griply/types';
import {
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';

export const updateExternalConnection = (
  externalConnection: Pick<ExternalConnection, 'id'> &
    Partial<ExternalConnection>,
): Promise<void> =>
  _updateExternalConnection({
    externalConnection,
    doc,
    updateDoc,
    db: getFirestore(),
    serverTimestamp,
  });
